import { Navigate, useLocation } from 'react-router-dom';
import { LoaderBar } from '../components/LoaderBar';
import { useAuth } from '../contexts/auth';

export function AuthGuard({ redirectPath = '/login', children }) {
  const { loading, isAuthenticated } = useAuth();
  const { pathname, search } = useLocation();
  if (loading) {
    return <LoaderBar />;
  }
  if (!isAuthenticated) {
    // Carries the page the user asked for, so the unified login can return them to it.
    return (
      <Navigate
        to={redirectPath}
        replace
        state={{ query: { redirectUrl: `${pathname}${search}` } }}
      />
    );
  }

  return children;
}
